export default __webpack_public_path__ + "static/media/Resume.40b8da29.pdf";